import React from 'react';
import '../styles/challenge.page.scss';
import { Row, Col, Container, Image } from 'react-bootstrap';
import BigText from '../components/BigText';
import rocketShip from '../assets/colabs_rocketship_white.svg';
import { EventTracker } from '../components/GoogleAnalytics';

export default function Challenge({ l }) {
    const category = 'covid';
    const action = `clicked the COVID alert banner to sign up for notifications`;
    console.log(l)
    return (
        <div className="challenge">
            <Container fluid className="pb-5">
                <Hero l={l} />
                {l.alert &&
                    <Row className="bg-primary text-white py-3 text-center">
                        <Col>
                            {l.alert} <a href={l.alertLink} className="text-white bold" style={{fontSize: '16px'}} onClick={() => EventTracker(category, action)}>{l.alertLinkText}</a>
                        </Col>
                    </Row>
                }
            </Container>
            <BigText text={l.big} />
            <div className="challenge_icon container text-center mt-1 mt-md-3">
                <div className="row">
                    {l.perks.map((perk, i) => (
                        <Col xs={12} md={3} key={`perk-${i}`}>
                            <Icon
                                src={perk.iconSrc}
                                alt={perk.iconAlt}
                                title={perk.title}
                            />
                        </Col>
                    ))}
                </div>
            </div>
            <Container className="mt-4">
                <Row className="">
                    <Col xs={12} md={11} className="h3 bold text-primary">
                        {l.explainerText}
                    </Col>
                </Row>
            </Container>
            <Container fluid className="mt-4 bg-primary py-2 py-md-5">
                <Container>
                    <Row>
                        <Col xs={12}>
                            <p className="h4 bold text-uppercase text-white">
                                {l.challengeTextTitle}
                            </p>
                        </Col>
                        <Col xs={12} className="pt-2 pb-5">
                            <p className="h1 text-white">
                                {l.challengeText}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    );
}

function Hero({ l }) {
    return (
        <div className="row">
            <div className="position-relative w-100">
                <div className="challenge__title m-auto d-flex align-items-center">
                    <div className="challenge__title_text d-flex flex-column text-white p-1 p-md-3">
                        <Image src={rocketShip} alt="co-labs logo of a rocketship" />
                        <span className="challenge__title_eyebrow hero-eyebrow text-center" dangerouslySetInnerHTML={{ __html: l.titleSuper }}></span>
                        <h1 className="hero-header text-center">
                            {l.title}
                        </h1>
                    </div>
                </div>
                <img src={l.heroImage} alt="" className="challenge__hero_image img-fluid w-100"></img>
            </div>
        </div>
    )
}

function Icon({ src, alt, title, copy }) {
    return (
        <div>
            <img src={src} alt={alt} className="img-fluid" />
            <p className={copy ? 'mt-1 mt-md-3 h4' : 'mt-1 mt-md-3 h4 text-center'}>
                {title}
            </p>
            <p>
                {copy}
            </p>
        </div>
    )
}
